import { render, staticRenderFns } from "./Ver2Vapp.vue?vue&type=template&id=0ef4f246&"
import script from "./Ver2Vapp.vue?vue&type=script&lang=js&"
export * from "./Ver2Vapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports